import {http} from '../core/http';

declare var staAjx: {
    ajaxNonce: string;
    ajaxUrl: string;
    form_id: string;
    post_id: any;
    [p: string]: any;
};

declare global {
    interface Window {
        loader: any;
        staAlert: any

        [p: string]: any
    }
}

export class AxjHandler {
    _ajaxNonce: string;
    _ajaxUrl: string;
    _data: any;
    _sta_ajx: any;
    _post_id: any;
    _zrt_server: any;

    setLocalizedParameters(paramsName?: string) {
        let params;
        if (paramsName && typeof window[paramsName] === 'object') {
            params = window[paramsName]
        } else if (typeof staAjx !== 'undefined') {
            params = staAjx;
        }

        if (params) {
            this._sta_ajx = params;
            this._ajaxUrl = params.ajaxUrl;
            this._ajaxNonce = params.ajaxNonce;
            this._post_id = params?.post_id
            this._zrt_server = params?._zrt_server
        }
    }

    loader(show: boolean = true) {
        if (typeof window.loader === 'function') {
            window.loader(show)
        }
    }

    async ajx(params: any) {
        let postData = {
            action: 'sta_modal_action',
            nonce: this._ajaxNonce,
        }

        if (params) {
            postData = Object.assign(postData, params);
        }
        this.loader(true);
        return http.wp(this._ajaxUrl, postData).then((res) => {
            this.loader(false);
            return res;
        }).catch((e) => {
            this.loader(false);
            console.error(e);
        });
    }

    // experimental: stats-handler.ts
    async post(params: any) {
        let postData = {
            action: '',
            nonce: this._ajaxNonce,
        }

        if (params) {
            postData = Object.assign(postData, params);
        }
        this.loader(true);
        return http.post2(this._ajaxUrl, postData).then((res) => {
            this.loader(false);
            return res;
        }).catch((e) => {
            this.loader(false);
            console.error(e);
        });
    }
}